<template>
    <div :class="{[positionX]:true, [positionY]:true, componentSelect: true , show: detailsState}" ref="details" :key="id">
      <summary @click="toggleDetails">
        <p>{{ data[valueSelect] || "" }}</p>
        <i class="fa-solid fa-caret-down"></i>
      </summary>
  
      <ul class="listOptions" ref="listOptions">
        <li v-for="keyData in Object.keys(data)" :key="keyData">
          <label>
            <input
              type="radio"
              :value="keyData"
              :checked="keyData === valueSelect"
              @change="handleChange"
            />
            <span>{{ data[keyData] }}</span>
          </label>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
    name: 'select',

    props : {
        valueSelect : String,
        changeValueSelect : Function,
        data : Object,
        
        id: {
            type : String,
            default : 'select'
        },

        getParentOverflow : {
            type : Function,
            default(){
                return document.querySelector('html');
            }
        },
        positionY : {
            type : String,
            default : 'bottom'
        },
        positionAuto : {
            type : Boolean,
            default : true
        },
        positionX : {
            type : String,
            default : 'right'
        },

    },
    data() {
        return {
            detailsState : false
        };
    },

    mounted() {
        
    },

    watch : {
        detailsState() {
            if (this.detailsState) {
                console.log('parentOverflow:', this.getParentOverflow());
                // Sélectionnez les éléments en question
                const parentElement = this.getParentOverflow();
                const listOptions = this.$refs.listOptions;
                const details = this.$refs.details;

                // Obtenez les positions de chaque élément
                const parentRect = parentElement.getBoundingClientRect();
                const detailsRect = details.getBoundingClientRect();

                


                if (this.positionAuto) {
                    if (parentRect.bottom < detailsRect.bottom + listOptions.offsetHeight) {
                        this.positionY =  "top";
                    }else{
                        this.positionY =  "bottom";
                    }
                }
               

        

                window.addEventListener('click', this.handleClickOutside);
            }else{
                window.removeEventListener("click", this.handleClickOutside, false);
            }
        }
    },

    methods: {
        toggleDetails(eventClick) {
            eventClick.stopPropagation();
            eventClick.preventDefault();
            this.detailsState = !this.detailsState;
        },

        handleChange(e) {
            
            this.changeValueSelect(e.target.value);
            this.detailsState = false;
        },

        handleClickOutside(event) {
            console.log("handleClickOutside")
            const targetElement = this.$refs.listOptions;
      
            if (!targetElement.contains(event.target)) {
                window.removeEventListener("click", this.handleClickOutside, false);
                this.detailsState = false;
            }
        },
    },

    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);
    },
};
</script>